import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateOptionGroup } from '../../api/apiOptionGroups';
import { toast } from 'react-hot-toast';
import parseError from '../../utils/parseError';

/**
 * Hook to update an option group
 */
export const useUpdateOptionGroup = () => {
    const queryClient = useQueryClient();

    const { mutate: editOptionGroup, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateOptionGroup(id, data),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['optionGroups'] });
            queryClient.invalidateQueries({ queryKey: ['optionGroup'] });
            toast.success(res?.data?.message);
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message);
        }
    });

    return { editOptionGroup, isUpdating };
};
